export enum Modality {
  WEIGHT_LIFTING = "WEIGHT_LIFTING",
  METCON = "METCON",
  GYM = "GYM",
}
